import { render } from "./SwitchTable.vue?vue&type=template&id=070fe7ea&scoped=true&ts=true"
import script from "./SwitchTable.vue?vue&type=script&lang=ts"
export * from "./SwitchTable.vue?vue&type=script&lang=ts"

import "./SwitchTable.vue?vue&type=style&index=0&id=070fe7ea&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\new2h5\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-070fe7ea"]])

export default __exports__